import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24CheckmarkW = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(1.5 1.5)",
      children: [/*#__PURE__*/jsx("rect", {
        width: 15,
        height: 15,
        rx: 2
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        d: "M10.753 2.898a.833.833 0 0 1 1.467.785l-.046.086-4.598 7.5a.834.834 0 0 1-1.316.137l-.07-.085-2.699-3.737a.833.833 0 0 1 1.285-1.057l.066.081 1.966 2.723z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24CheckmarkW$1 = Svg24CheckmarkW;

export { Svg24CheckmarkW$1 as default };
